import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { I18N } from "./translations";

const Ctx = createContext({ lang: "en", setLang: () => {}, t: (s) => s });
const STORAGE_KEY = "sol_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "es") return stored;
    const browser = (window.navigator?.language || "en").slice(0, 2);
    return browser === "es" ? "es" : "en";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, lang);
      if (document?.documentElement) {
        document.documentElement.lang = lang;
      }
    }
  }, [lang]);

  const setLang = useCallback((next) => {
    if (next === "en" || next === "es") setLangState(next);
  }, []);

  const t = useCallback(
    (englishKey) => {
      if (lang === "en") return englishKey;
      const dict = I18N[lang];
      if (!dict) return englishKey;
      return dict[englishKey] ?? englishKey;
    },
    [lang],
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useT() {
  return useContext(Ctx);
}
